<template>
  <div class="box">
    <div class="p-5 border-b border-gray-200 dark:border-dark-5">
      <h2 class="font-medium text-base">{{ $t('text.bankInformation') }}</h2>
    </div>
    <div class="p-5">
      <InputSelect
        :label="$t('text.nameOfCustomerBank')"
        :options="banks"
        value-key="id"
        v-model.number="vForm.bank.id.$model"
        :vuelidate="vForm.bank.id"
      />
      <InputString
        :label="$t('text.nameOfBankAccount')"
        v-model.trim="vForm.bank.accountHolder.$model"
        :vuelidate="vForm.bank.accountHolder"
      />
      <InputString
        :label="$t('text.numberOfBankAccount')"
        v-model.trim="vForm.bank.accountNumber.$model"
        :vuelidate="vForm.bank.accountNumber"
      />
      <InputString
        :label="$t('text.loanLimit')"
        v-model.trim="vForm.amount.$model"
        :vuelidate="vForm.amount"
      />
    </div>
  </div>
</template>

<script>
import InputString from '@/components/ui/input/InputString';
import InputSelect from '@/components/ui/input/InputSelect';

export default {
  props: {
    form: Object,
    vForm: Object,
    banks: Array,
  },

  components: {
    InputString,
    InputSelect,
  },
};
</script>
